import { useForm } from 'react-hook-form';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';
import CommonPatientInfo from '../../components/CommonPatientInfo';
import { SurveyDialogProps, TConsentForSurgeryDefaultValues } from '../../type';
import Agreement from './Agreement';
import Signature from './Signature';
import { updateConsentForSurgery } from 'apis/survey';

export default function ConsentForSurgery(
  props: SurveyDialogProps<TConsentForSurgeryDefaultValues>
) {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TConsentForSurgeryDefaultValues) => {
    const {
      select_category,
      surgery_start_date,
      on_call,
      disease_name,
      surgery_name,
      main_doctor_name,
      main_doctor_sign,
      past_disease,
      special_constitution,
      blood_pressure,
      heart_disease,
      accident_caused_by_medicine,
      allergy,
      diabete,
      blood_cause,
      drug_accident,
      address,
      phone,
      personal_number,
      created_date,
      patient_name,
      patient_sign,
      next_of_kin_name,
      next_of_kin_sign,
    } = data;

    const request = {
      userId: user_id,
      patientId: patientInfo.patient_id,
      surgeryAgreement: {
        select_category,
        surgery_start_date,
        on_call,
        disease_name,
        surgery_name,
        main_doctor_name,
        main_doctor_sign,
        past_disease,
        special_constitution,
        blood_pressure,
        heart_disease,
        accident_caused_by_medicine,
        allergy,
        diabete,
        blood_cause,
        drug_accident,
        address,
        phone,
        personal_number,
        created_date,
        patient_name,
        patient_sign,
        next_of_kin_name,
        next_of_kin_sign,
      },
    };

    updateConsentForSurgery(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        수술동의서
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <Agreement {...formProps} />
        <Signature {...formProps} />
      </Box>

      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '500',
          fontSize: '22px',
          textAlign: 'center',
          letterSpacing: '10px',
        }}
      >
        한국성서대학병원
      </Typography>
      <div style={{ width: '100%' }}>
        <span
          style={{
            color: '#14855B',
            float: 'right',
            marginTop: '10px',
            fontSize: '12px',
          }}
        >
          해당 기록지는 한국성서대학교 간호학과의 협조를 통해 제작하였습니다
        </span>
      </div>
    </MuiDialog.SurveyForm>
  );
}
